import 'boxicons';
import React from 'react';
import { Menu } from 'antd';

const navItems = [
    {
        display: 'Por categoría',
        icon: <box-icon name='dots-vertical'color="white" />,
        to: 'category',
    },
    {
        display: 'Tabla',
        icon: <box-icon name='table'color="white" />,
        to: 'table',
    },
    {
        display: 'Contáctanos',
        icon: <box-icon type='solid' color="white" name='contact'/>,
        to: 'contactUs',
    }

  ];

  const MyMenu = ( { setMenu } ) => (
    <Menu
        style={{textAlign: 'left'}}
        theme="dark"
        mode="inline"
        defaultSelectedKeys={['/']}
        items={navItems.map(
        (item) => {
            return {
                key: item.to,
                icon: item.icon,
                label: item.display,
            };
        },
        )}
        onSelect={(e) => {setMenu(e.key);}}
    />
);

export default MyMenu;
